import React from "react";
import environments from "../../utils/config/environments";

export const FloatingContactUsButton = () => {
  return (
    <a
      className="FloatingContactUsButton"
      href={environments.whatsAppLink}
      target="_blank"
      rel="noreferrer"
    >
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="30" cy="30" r="30" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.9194 46.1187C39.9056 44.8171 46.0542 37.7524 46.0542 29.1667C46.0542 19.6487 38.4979 12 29.2586 12C20.0194 12 12.4631 19.6487 12.4631 29.1667C12.4631 30.898 12.7131 32.5675 13.1778 34.1404C13.1682 34.1486 13.1586 34.1569 13.149 34.1652C13.499 35.0422 13.9033 35.8231 14.3547 36.4562C14.3152 36.4568 14.2756 36.4572 14.236 36.4572C10.2397 36.4572 7 33.0682 7 28.8876C7 25.5467 9.06899 22.7114 11.9397 21.7072C14.7928 14.8274 21.4729 10 29.2586 10C37.0422 10 43.7207 14.8247 46.5752 21.7014C50.1902 22.1195 53.0009 25.2997 53.0009 29.1609C53.0009 33.0203 50.1928 36.1993 46.5802 36.6198C44.0815 42.6513 38.6417 47.1065 32.0937 48.1167C31.7614 49.2074 30.7532 50.0003 29.561 50.0003C28.0982 50.0003 26.9123 48.8064 26.9123 47.3337C26.9123 45.8609 28.0982 44.667 29.561 44.667C30.5892 44.667 31.4805 45.2568 31.9194 46.1187ZM29.4648 41.6667C36.686 41.6667 42.54 35.6971 42.54 28.3333C42.54 20.9695 36.686 15 29.4648 15C22.2436 15 16.3896 20.9695 16.3896 28.3333C16.3896 32.1291 17.945 35.5544 20.4413 37.9826L18.5294 43.3507C18.2079 44.2532 19.2082 45.0532 20.0087 44.5339L25.4267 41.0187C26.6984 41.4393 28.0556 41.6667 29.4648 41.6667Z"
          fill="#7F9B28"
        />
      </svg>
    </a>
  );
};
